import {
    CREATE_PRODUCT_MEMBERSHIP,
    CREATE_PRODUCT_MEMBERSHIP_FAILURE,
    CREATE_PRODUCT_MEMBERSHIP_SUCCESS,
} from 'store/actions/types';

export const createProductMembreship = (payload) => {
    return {
        type: CREATE_PRODUCT_MEMBERSHIP,
        payload: payload,
    };
};

export const createProductMembreshipFailure = (error) => {
    return {
        type: CREATE_PRODUCT_MEMBERSHIP_FAILURE,
        error: error,
    };
};

export const createProductMembreshipSuccess = (response) => {
    return {
        type: CREATE_PRODUCT_MEMBERSHIP_SUCCESS,
        id: response.id,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/product-memberships/createProductMembership.js